import * as React from 'react';
export const girocardSvg = React.forwardRef(function girocardSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22.005 13.5H20.19v.411h1.43l3.606 12.416H6.775l3.606-12.416h1.43V13.5H9.994L6 26.833h20L22.005 13.5Z',
      fill: '#1F3A6A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M20.156 5.167h-8.312c-.465 0-.844.35-.844.782v7.55h.625V5.95c0-.11.1-.203.22-.203h1.548v5.446h-1.628l2.333 2.308h3.804l2.333-2.308h-1.628V5.746h1.549c.119 0 .219.093.219.203v7.55H21V5.95c0-.431-.378-.782-.844-.782Z',
      fill: '#5DC4E9',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.004 22.35h3.034a.34.34 0 0 0 .346-.359l-.117-1.952a.392.392 0 0 0-.388-.36h-2.716a.392.392 0 0 0-.388.36l-.116 1.952a.34.34 0 0 0 .345.36Zm-1.297-2.67h-2.74c-.202 0-.4.158-.44.353l-.402 1.964c-.04.195.093.354.295.354h3.055c.202 0 .38-.162.398-.36l.17-1.953a.328.328 0 0 0-.335-.358Zm1.42-.617h2.79c.161 0 .285-.13.276-.287l-.093-1.562a.313.313 0 0 0-.31-.288h-2.535a.313.313 0 0 0-.311.288l-.093 1.562a.271.271 0 0 0 .276.287Zm-1.107-2.137h-2.563a.373.373 0 0 0-.35.283l-.323 1.572c-.032.155.074.282.236.282h2.814a.324.324 0 0 0 .319-.287l.136-1.563a.263.263 0 0 0-.268-.287Zm7.995 2.137c.162 0 .268-.127.236-.282l-.324-1.572a.373.373 0 0 0-.351-.283h-2.554a.263.263 0 0 0-.268.288l.136 1.562a.324.324 0 0 0 .318.287h2.808Zm-6.765-2.66h2.545c.141 0 .25-.114.242-.252l-.072-1.206a.274.274 0 0 0-.272-.251h-2.342a.274.274 0 0 0-.272.251l-.072 1.206c-.008.138.1.252.242.252Zm6.256 0c.14 0 .234-.112.206-.247l-.25-1.215a.327.327 0 0 0-.308-.247h-2.362a.23.23 0 0 0-.235.25l.105 1.207a.283.283 0 0 0 .279.252h2.565Zm-7.254-1.709H10.88a.326.326 0 0 0-.308.247l-.249 1.214c-.027.136.065.248.207.248h2.574a.284.284 0 0 0 .279-.252l.105-1.206a.23.23 0 0 0-.235-.251Zm8.368 7.656c.201 0 .334-.158.294-.352l-.405-1.965a.467.467 0 0 0-.44-.353h-2.733a.328.328 0 0 0-.336.358l.17 1.954a.405.405 0 0 0 .399.359h3.05Zm-4.61.726h-2.974a.47.47 0 0 0-.466.431l-.147 2.476a.407.407 0 0 0 .414.431h3.371a.407.407 0 0 0 .415-.431l-.148-2.476a.47.47 0 0 0-.466-.431Zm-4.672 0H9.345a.56.56 0 0 0-.527.423l-.51 2.492c-.048.233.11.424.353.424h3.386a.486.486 0 0 0 .478-.431l.216-2.478a.394.394 0 0 0-.402-.43Zm9.885.424a.56.56 0 0 0-.528-.424h-2.99a.394.394 0 0 0-.403.43l.216 2.478c.02.237.236.43.478.43h3.387c.242 0 .4-.19.353-.423l-.513-2.492Z',
      fill: '#1F3A6A',
    }),
  );
});
girocardSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var girocard = {
  category: 'brand',
  colorable: false,
  name: 'girocard',
  svg: girocardSvg,
};
